import React, {Component} from 'react';
import _ from 'lodash';
import accounting from 'accounting';
import { Image, Segment, Container, Icon, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getAutoLoanData, storeSimulateEmail } from '../../redux/actions';
import {submitFeedback} from '../../core/apiClient';
import {getConst} from '../../core/consts';
import $ from 'jquery';
import {getStaticText} from '../../core/lang';

class SidePdp extends Component {
  constructor() {
    super();
    this.state = {
      form: {
        rating: 0,
        fullName: '',
        emailId: '',
        comment: '',
      },
      errors: {
        rating : '',
        fullName: '',
        emailId: '',
        comment: ''
      },
      activeIndex: 0,
    }
  }

  handleInputChange = (e, {value, name}) => {
    if(name === 'emailId'){
      value = value.trim();
    }
    if(name === 'fullName'){
      value = value.toUpperCase();
    }
    const form = _.assign(this.state.form, {[name]: value})
    this.setState({
      form
    })
  }

  onRating = (e, {rating}) => {
    const form = _.assign(this.state.form, {rating: rating})
    this.setState({
      form
    })
    this.handleRatingBlur();
  }
  handleFullNameBlur = () => {
    let valid = false;
    const {info_required_msg, only_alphanumeric_msg} = getStaticText(this.props.activeLanguage);
    const {alphaNumSpaceRegex} = getConst(this.props.activeLanguage);
    if (!alphaNumSpaceRegex.test(this.state.form.fullName)) {
      this.createError('fullName', only_alphanumeric_msg)
    } else if (_.isEmpty(this.state.form.fullName)) {
      this.createError('fullName', info_required_msg);
    } else {
      this.createError('fullName', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }
  handleEmailIdBlur = () => {
    let email = this.state.form.emailId;
    if (_.isEmpty(email)) {
      email = this.props.simulateEmail;
    }
    let valid = false;
    const {email_id_required_msg, email_id_valid_msg} = getStaticText(this.props.activeLanguage);
    const {emailRegex} = getConst(this.props.activeLanguage);
    if (_.isEmpty(email)) {
      this.createError('emailId', email_id_required_msg);
    } else if (!emailRegex.test(email)) {
      this.createError('emailId', email_id_valid_msg);
    }else {
      this.createError('emailId', '');
      valid = true;
    }
    this.onFocusField('')
    return valid
  }
  handleCommentBlur = () => {
    let valid = false;
    const {comment_invalid_message} = getStaticText(this.props.activeLanguage);
    if (_.isEmpty(this.state.form.comment) || this.state.form.comment.length > 300 || this.state.form.comment.length < 3) {
      this.createError('comment', comment_invalid_message);
    } else {
      this.createError('comment', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }
  handleRatingBlur = () => {
    let valid = false;
    const {please_rate_us} = getStaticText(this.props.activeLanguage);
    if (!this.state.form.rating) {
      this.createError('rating', please_rate_us);
    } else {
      this.createError('rating', '');
      valid = true;
    }
    return valid;
  }
  createError = (field, error) => {
    const errors = _.assign(this.state.errors, {[field]: error})
    this.setState({
      errors
    })
  }

  submitFeedback = () => {
    const fullNameValid = this.handleFullNameBlur(),
    emailValid = this.handleEmailIdBlur(),
    commentValid = this.handleCommentBlur(),
    ratingValid   = this.handleRatingBlur();
  if (fullNameValid && emailValid && commentValid && ratingValid) {
    let email = this.state.form.emailId;
      if (_.isEmpty(email)) {
        email = this.props.simulateEmail;
      }
      submitFeedback(this.props.cardDetails.id, {
        'customer': {
          'full_name': this.state.form.fullName,
          'email': email,
        },
        'feedback': {
          'rating': this.state.form.rating,
          'comments': this.state.form.comment,
        }
      }

      ).then((response) => {
        this.props.storeSimulateEmail(email, false);
        this.setState({
          form: {
            rating: 0,
            fullName: '',
            emailId: '',
            comment: '',
          }
        })
        this.props.getAutoLoanData();
        setTimeout(() => {
          this.props.changePdpByCardId(this.props.cardDetails.id);
          this.setState({activeIndex: 0})
        }, 3000)
        // this.props.closeSidePdp()
      })
    }
  }

  handleTabChange = (e, { activeIndex }) => this.setState({ activeIndex })

  onFocusField = (name) => {
    this.setState({onFocus: name})
  }

  toggleReview = (e) => {
    if($('.js-goto-feedback').hasClass('active')) {
      $('.js-goto-feedback').removeClass('active');
      $('.sidebar-container').animate({
        scrollTop: 0
      }, 800)
    } else {
      $('.js-goto-feedback').addClass('active');
      $('.sidebar-container').animate({
        scrollTop: $('.sidebar-container #feedback-comments').offset().top - 210
      }, 800)
    }
  }

  simulatorOpen = () => {
    this.props.closeSidePdp();
    this.props.simulatorOpen();
  }

  resetCommentForm = () => {
    this.setState({
      form: {
        rating: 0,
        fullName: '',
        emailId: '',
        comment: '',
      }
    })
  }

  editSimulateEmail = () => {
    const form = _.assign(this.state.form, {emailId: this.props.simulateEmail})
    this.setState({
      form
    });
    this.props.storeSimulateEmail('', true);
  }

  render() {
    const lang = getStaticText(this.props.activeLanguage);
    const props = this.props;
    return (
      <Container>
        <Button className='sidebar-close' onClick={props.closeSidePdp}><i className='icon close'></i></Button>
        <div className='sidebar-container'>
        <div className='sidebar-parent fromEditor'>
          <Segment.Group horizontal className='ui basic segment sidebar-img' title={props.cardDetails.contract?'':lang.non_contract_alert_less}>
            <Segment className='ui basic segment no-border-left sidebar-detail'>
              <Image alt={props.cardDetails.bankName+" "+props.cardDetails.name} src={props.cardDetails.logo+lang.auto_compress} size='small' />
              <div className='card-right-pos'>
                <h3>{props.cardDetails.bankName} <p>{props.cardDetails.name}</p></h3>
                {/* <Rating icon='star' maxRating={5} rating={props.cardDetails.rating} disabled />
                <span className='rating-count'>({props.cardDetails.numberOfReviews})</span> */}
              </div>
            </Segment>
            <Button className='btn btn-blue'  onClick={(e)=>{this.props.applyDirect(e,props.cardDetails.id); props.closeSidePdp();}}>{lang.apply}</Button>
            {/* {props.cardDetails.contract?
            <Button className='btn btn-blue'  onClick={(e)=>{this.props.applyDirect(e,props.cardDetails.id); props.closeSidePdp();}}>{lang.apply}</Button>:
            <span className='applyBtn' title={props.cardDetails.contract? '':lang.non_contract_alert_less}><Button className='btn btn-blue disabled'>{lang.apply}</Button></span>
            } */}
            {_.has(props, 'enableButton') && props.enableButton.allowChange?<Segment className="sidebar-nav ui basic segment no-border-left">
              {props.enableButton.next?<Button card={props.cardDetails} changeby={1} onClick={this.props.changeSidePdp}><Icon name="chevron right" /></Button>:''}
              {props.enableButton.previous?<Button card={props.cardDetails} changeby={-1} onClick={this.props.changeSidePdp}><Icon name="chevron left" /></Button>:''}
              <span className='cta-link js-goto-feedback hide' onClick={this.toggleReview} >{lang.comments_and_feedback} ({_.isEmpty(props.cardDetails.comments)?0:  _.filter(props.cardDetails.comments, { 'publish': true }).length  })) <Icon name='chevron down' /> </span>
            </Segment>:''}
          </Segment.Group>
          <Segment className='ui basic segment sidebar-para'>
            <div  dangerouslySetInnerHTML={{__html:_.upperFirst(props.cardDetails.description) }}></div>
          </Segment>
          <ul className='sidebar-combo'>
           <li>
             <h5>{lang.minimum_salary_required} ({lang.aed})</h5>
            <p>{accounting.formatMoney(props.cardDetails.minimumSalary, '', 0)}</p>
           </li>
           <li>
            <h5>{props.cardDetails.id === 773 ? 'Finance Amount' : lang.loan_amount} ({lang.aed})</h5>
            <p>{accounting.formatMoney(props.cardDetails.maxLoanAmount, '', 0)}</p>
            </li>
           <li>
            <h5>{props.cardDetails.id === 707 ? 'Flat Rate' : lang.fixed_rate} (%)</h5>

            {!_.isUndefined(props.cardDetails.fixedRate)?<p>{props.cardDetails.fixedRate.toFixed(2)}</p>: ''}
            </li>
           <li>
            <h5>{lang.reducing_rate} (%)</h5>
            {!_.isUndefined(props.cardDetails.reducingRate)?<p>{props.cardDetails.reducingRate.toFixed(2)}</p>: ''}
            </li>
           <li>
            <h5>{lang.down_payment} (%)</h5>
            {!_.isUndefined(props.cardDetails.downPayment)?<p>{props.cardDetails.downPayment.toFixed(2)}</p>: ''}
          </li>
          </ul>
          <div className='sidebar-section'>
            {_.isEmpty(props.cardDetails.topReasons)?'':<div className='sidebar-list-wrap'>
              <h3>{lang.top_reason_to_choose}</h3>
              <ul className='list-check'>
                {props.cardDetails.topReasons.map((item, idx) => (
                  <li key={idx}>{_.upperFirst(item)}</li>
                ))}
              </ul>
            </div>}
            {
              _.isEmpty(props.cardDetails) ? ''
              :
              <div>
                {_.isEmpty(props.cardDetails.thingsToAware.filter(Boolean))?'':<div className='sidebar-list-wrap'>
                  <h3>{lang.things_to_aware}</h3>
                    <ul className='quick-view-list list ul-minusStyle'>
                    {props.cardDetails.thingsToAware.map((item, idx) => (
                      <li key={idx}>{_.upperFirst(item)}</li>
                    ))}
                    </ul>
                </div>}
              </div>
            }
          </div>
          {_.isEmpty(props.cardDetails.card_details)?'':<div className='sidebar-section'>
            <div className='sidebar-list-wrap sidebar-list-wrap-sec'>
              <h3>{lang.detailed_features}</h3>
              <div className="card-descp" dangerouslySetInnerHTML={{__html:_.upperFirst(props.cardDetails.card_details) }}></div>
            </div>
          </div>}
          {props.cardDetails.joiningOffers ?
            <div className='sidebar-section'>
            <div className='sidebar-list-wrap sidebar-list-wrap-sec'>
              <h3>{lang.joining_offers}</h3>
              <div  dangerouslySetInnerHTML={{__html:_.upperFirst(props.cardDetails.joiningOffers) }}></div>
            </div>
          </div>
          :null
        }
        {props.cardDetails.documentsRequired ?
            <div className='sidebar-section'>
            <div className='sidebar-list-wrap sidebar-list-wrap-sec'>
              <h3>{lang.documents_required}</h3>
              <div className="card-descp"  dangerouslySetInnerHTML={{__html:_.upperFirst(props.cardDetails.documentsRequired) }}></div>
            </div>
          </div>
          :null
        }
        {props.cardDetails.eligiblity ?
            <div className='sidebar-section'>
            <div className='sidebar-list-wrap sidebar-list-wrap-sec'>
              <h3>{lang.eligiblity}</h3>
              <div className="card-descp" dangerouslySetInnerHTML={{__html:_.upperFirst(props.cardDetails.eligiblity) }}></div>
            </div>
          </div>
          :null
        }
        </div>
        {/* <div className='sidebar-parent' id='feedback-comments'>
          <Segment className='sidebar-section-sec'>
            <h3>{lang.discussion_board}</h3>
            <Tab menu={{ secondary: true, pointing: true }} activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} panes={[
              {
                menuItem: `${lang.comments_and_feedback} (${_.isEmpty(props.cardDetails.comments)?0: _.filter(props.cardDetails.comments, { 'publish': true }).length })`,
                render: () => (<Tab.Pane attached={false}>
                  {!_.isEmpty(props.cardDetails.comments)?
                  <div className='feedback-box-wrap'>
                    {props.cardDetails.comments.map((item, idx) => {
                      if(item.publish){
                        return(
                        <div key={idx} className='feedback-box'>
                          <div className='user-icon'><i className='icon user'></i></div>
                          <p><Rating icon='star' defaultRating={item.rating} maxRating={5} disabled/></p>
                          <p>{item.comment}</p>
                          <p className="author-name">{lang.posted_by}{item.name}</p>
                        </div>
                      )}else{
                        return(null);
                      }
                  })}
                  </div>:
                  <div>{lang.no_comments}</div>}
                </Tab.Pane>)
              },
              {
                menuItem: `${lang.write_new_comment}`,
                render: () => (<Tab.Pane attached={false}>
                    <Form className='comment-box custom-form'>
                      <Label className='rating-label'>{lang.rating} :</Label>
                      <div className='form-control'>
                      <Rating
                        maxRating={5}
                        rating={this.state.form.rating}
                        onRate={this.onRating}
                        name='rating'
                      />
                      <span className='input-error'>{this.state.errors.rating}</span>
                      </div>
                      <div className='form-control comment-form'>
                        <span className={!_.isEmpty(this.state.form.fullName) || this.state.onFocus === 'fullName'?'label-animate active': 'label-animate'}>{lang.full_name} <span className='asterik'>*</span></span>
                        <Form.Input
                          value={this.state.form.fullName}
                          onChange={this.handleInputChange}
                          name='fullName'
                          onBlur={this.handleFullNameBlur}
                          maxLength={30}
                          onFocus={(value) => this.onFocusField('fullName')}
                        />
                        <span className='input-error'>{this.state.errors.fullName}</span>
                      </div>
                      {this.props.allowInput?
                        <div className='form-control comment-form'>
                          <span className={!_.isEmpty(this.state.form.emailId) || this.state.onFocus === 'emailId'?'label-animate active': 'label-animate'}>{lang.email_id}<span className='asterik'>*</span></span>
                          <Form.Input
                            value={this.state.form.emailId}
                            onChange={this.handleInputChange}
                            name='emailId'
                            onBlur={this.handleEmailIdBlur}
                            maxLength={50}
                            onFocus={(value) => this.onFocusField('emailId')}
                          />
                          <span className='input-error'>{this.state.errors.emailId}</span>
                        </div>:
                        <div className='form-control form-control--email'>
                          <span className='label label-email'>{lang.email_id} <span className='asterik'>*</span></span>
                          <Button onClick={this.editSimulateEmail} className='email-edit-icon'>
                            {this.props.simulateEmail}</Button>
                        </div>
                      }
                      <div className='form-control'>
                        <Form.TextArea
                          label={<span className='label-animate active'>{lang.comments} <span className='asterik'>*</span></span>}
                          value={this.state.form.comment}
                          placeholder=''
                          onChange={this.handleInputChange}
                          name='comment'
                          onBlur={this.handleCommentBlur}
                          maxLength={300}
                        />
                        <span className='input-error'>{this.state.errors.comment}</span>
                      </div>
                      <Button className='btn btn-link' onClick={this.resetCommentForm} type='reset'>{lang.clear_all}</Button>
                      <Button className='btn btn-blue right' onClick={this.submitFeedback} type='submit'>{lang.submit}</Button>
                    </Form>
                  </Tab.Pane>
                )},
            ]} />
          </Segment>
        </div> */}
      </div>
      </Container>
  )
  }

}

const mapStateToProps = (state, ownProps) => ({
  allowInput: state.simulateEmail.allowInput,
  simulateEmail: state.simulateEmail.email,
  activeLanguage: state.activeLanguage,
});

const mapDispatchToProps = {
  getAutoLoanData,
  storeSimulateEmail,
};

const SidePdpContainer = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(SidePdp));

export default SidePdpContainer;



// WEBPACK FOOTER //
// ./src/components/autoLoans/SidePdp.js